export default "__VITE_ASSET__8mncPPF3__"